<template>
  <div class="modelpage">
    <div v-if="showdwg" class="column-left">
      <div class="resize-bar" title="拖动" @mouseout="getWidth"></div>
      <div class="resize-line"></div>
      <i v-show="showdwg" class="el-icon-close closed" :style="{ left: resizeListening - 30 + 'px' }" title="关闭图纸"
        @click="closeDwg"></i>
      <div id="dwgbox" class="resize-save"></div>
    </div>
    <div id="modelbox" class="column-right" @contextmenu.prevent="onContextmenu"></div>
    <div v-if="showMenu" ref="menu" class="rightCliMenu"
      :style="{ left: rightMeauLift + 'px', top: rightMeauTop + 'px' }">
      <ul>
        <li v-for="(item, index) in menuList" v-show="item.vis" :key="index" @click="onFunc(index, menuType)">
          {{ item.v }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import modelLoaderV1 from "@/views/components/model/modelLoaderV1";
import modelLoaderMLib from "@/views/components/model/modelLoaderMLib";
import { mapState } from "vuex";
import docService from "@/CommonDP/service/doc-service";

export default {
  data() {
    return {
      prjName: "",
      fileName: "",
      showMenu: false, // 右键属性
      menuList: [
        { vis: true, v: "取消" },
        { vis: true, v: "隐藏" },
        { vis: true, v: "透明" },
        { vis: true, v: "隔离" },
        { vis: true, v: "居中" },
        { vis: true, v: "所有实例" },
        { vis: true, v: "取消透明" },
        { vis: true, v: "全部显示" }
      ],
      menuType: 0,
      rightMeauLift: 0, // 右键菜单左边距
      rightMeauTop: 0, // 右键菜单顶部
      resizeListening: 960,
      showdwg: false,
      model2dwg: [],
      modelIdx: 0,
      modelMap: [],
      mapModel: [],
      // 是事启动新的模式， true 为启用
      mlibEnabled: false
    };
  },
  computed: {
    ...mapState({
      modelUrlData: state => state.monge.modeldata,
      modelProperty: state => state.monge.modelProperty,
      modelPageFileName: state => state.monge.modelPageFileName,
      spaceQmList: state => state.monge.spaceQmList, // 当前空间下的所有问题列表
      hasDwg: state => state.monge.hasDwg
    }),

    modeldata() {
      return modelLoaderV1.modeldata || [];
    }
  },
  beforeCreate() {
    if (this.$route.query.fileNames) {
      document.title = this.$route.query.fileNames;
    }
  },
  created() {
    this.initParams();
  },
  mounted() {
    this.doLoadModel();
  },

  beforeDestroy() {},
  methods: {
    async initParams() {
      if (this.$route.query.fileIds) {
        const fId = this.$route.query.fileIds.split(",");
        const fName = this.$route.query.fileNames.split(",");
        const versionID = this.$route.query.versionId || "";
        const versionIds = this.$route.query.versionIds || "";
        const versionName = this.$route.query.versionName || "";
        const prjId = this.$route.query.prjId || "";
        const folderID = this.$route.query.parentId || "";
        const rvtVersion = this.$route.query.rvtVersion.split(",");
        if (fId.length == "1") {
          // 单模型
          this.fileName = fName[0];
          const modeldatas = {
            fileId: fId[0],
            fileName: fName[0],
            versionID,
            versionName,
            prjId,
            rvtVersion: rvtVersion[0]
          };
          this.$store.dispatch("setModeldata", modeldatas);
        } else if (fId.length > 1) {
          // 整合模型
          const fileObj = [];
          for (let i = 0; i < fId.length; i++) {
            const ele = {
              folderID: fId[i],
              folderName: fName[i],
              rvtVersion: rvtVersion[i]
            };
            fileObj.push(ele);
          }
          const modeldatas = {
            fileObj,
            prjId: prjId,
            versionID: versionIds,
            versionName: versionName,
            folderID: folderID
          };
          this.$store.dispatch("setModeldata", modeldatas);
        }
      } else {
        this.$error("未获取模型id");
        return;
      }
    },

    async doLoadModel() {
      if (this.modelUrlData.fileId) {
        await this.queryConvertMode();
      } else {
        await this.queryAllConvertMode();
        // this.mlibEnabled = true;//整合模型按照新的接口需求来
      }
      try {
        if (this.mlibEnabled) {
          await this.loadModelFromMLib();
        } else {
          await this.getModelUrl();
        }
      } catch (e) {
        console.log(e);
        this.$error(e.message || "加载模型错误");
      }
    },

    async queryConvertMode() {
      try {
        const rvtId = this.modelUrlData.fileId;
        const rvtVersion = this.modelUrlData.rvtVersion || "";
        const res = await docService.queryConvertMode(rvtId, rvtVersion);
        this.mlibEnabled = res.data && res.data === 1;
      } catch (e) {
        this.mlibEnabled = false;
      }
      return Promise.resolve();
    },

    async queryAllConvertMode() {
      try {
        const list = this.modelUrlData.fileObj;
        const resList = [];
        for (const iterator of list) {
          const res = await docService.queryConvertMode(iterator.folderID, iterator.rvtVersion);
          resList.push(res.data && res.data === 1);
        }
        this.mlibEnabled = !resList.some(ele => !ele);
        if (!this.mlibEnabled) {
          this.$error("新旧模型不能整合");
          setTimeout(() => {
            window.close();
          }, 3000);
        }
      } catch (error) {
        this.mlibEnabled = false;
      }
      return Promise.resolve();
    },
    // 模型参数
    async getModelUrl() {
      const opt = {
        callBack: a => {
          const models = this.modeldata || [];
          if (a === Monge.LoadState.attribute) {
            this.$parent.modelLoaded = true;
            this.$nextTick(() => {
              this.$store.dispatch("setHasDwg", false);
              const modelinfos = Monge.Model.getModels();
              this.modelIdx = modelinfos.find(m => m.url == models[0]).id;
              this.onModelMenu();
            });
          }
        },
        effect: ECHO.Constant.EffectType.Render + ECHO.Constant.EffectType.Sky
      };

      modelLoaderV1.load(this.modelUrlData, opt);
    },

    loadModelFromMLib() {
      const opt = {
        callBack: a => {
          const models = modelLoaderMLib.models || [];
          if (a === Monge.LoadState.attribute) {
            this.$emit("isShowTask")
            this.$parent.modelLoaded = true;
            this.$nextTick(() => {
              const modelinfos = Monge.Model.getModels();
              this.modelIdx = modelinfos.find(m => m.url == models[0]).id;
              this.onModelMenu();
            });
          }
        },
        effect: ECHO.Constant.EffectType.Render + ECHO.Constant.EffectType.Sky
      };

      modelLoaderMLib.load(this.modelUrlData, opt);
    },


    closeDwg() {
      document.getElementById("dwgbox").innerHTML = "";
      this.$parent.$refs.Mbutton.marginLeft = 0;
      this.$parent.marginLeft = 0;
      this.$parent.showdwg = false;
      this.showdwg = false;
      this.$nextTick(() => {
        Monge.Model.resize();
        this.$store.dispatch("setHasDwg", false);
        Monge.Map.unload("dwgbox");
        this.$store.dispatch("setmodelPageFileName", "");
        this.$store.dispatch("setAnnotationData", "");
      });
    },
    openDwg(list, drawName) {
      this.showdwg = true;
      const opt = {
        callBack: async a => {
          if (a.geometry) {
            Monge.Model.resize();
            this.$store.dispatch("setHasDwg", true);
            this.$store.dispatch("setSpaceQmList", "");
            this.$parent.showdwg = true;
            await this.mapLinkModel();
            this.addListenDwgProp();
            this.dealAnnotation();
          }
        }
      };
      opt.isOssFile = true;
      this.$nextTick(() => {
        this.$parent.$refs.Mbutton.marginLeft = document.body.clientWidth / 2;
        this.$parent.marginLeft = document.body.clientWidth / 2;
        document.getElementById("dwgbox").innerHTML = "";
        // Monge.Map.LoadBimd("dwgbox", picsurl, opt);
        try {
          const bimexDetailList = [];
          list
            .filter(ele => ele.label == "2D")
            .forEach(e => {
              if (!e.drawName) {
                return;
              }
              const bimexItemFile = {
                originFileName: e.lightFileName,
                url: e.downloadUrl,
                fileId: e.fileId
              };
              bimexDetailList.push(bimexItemFile);
            });
          const spaceWithDetailItems = {
            bimexId: drawName,
            bimexName: drawName,
            convertFilePathId: drawName,
            bimexDetailList
          };
          Monge.Map.LoadBimd("dwgbox", spaceWithDetailItems, opt);
        } catch (e) {
          console.debug(e);
          this.$error(e.message || "加载图纸错误");
        }
      });
    },
    dealAnnotation() {
      // 批注云线点击事件
      Monge.Map.Annotation.activeManager({
        callback: (type, data) => {
          if (type === Monge.CallbackType.DBCLICK) {
            if (!!this.annotationData && this.annotationData.flag23d == 2) {
              // 有定位
              this.$parent.$refs.detailNotation.init(this.annotationData);
            } else {
              if (this.spaceQmList.some(ele => ele.mongeId == data)) {
                const rowdata = this.spaceQmList.filter(ele => ele.mongeId == data)[0];
                this.$parent.$refs.detailNotation.init(rowdata.element);
              }
            }
          }
        }
      });
      this.$nextTick(() => {
        // 切换布局空间 -- 点击云线的定位
        if (!!this.annotationData && this.annotationData.flag23d == 2) {
          const data =
            this.annotationData.source === "WEB端"
              ? JSON.parse(this.annotationData.coordinate)
              : JSON.parse(this.annotationData.anchorPoint);
          switch (this.annotationData.queStatus) {
            case "待修改":
              data.stMarkNewInfo.color = Number("0xd81e06");
              break;
            case "已修改":
              data.stMarkNewInfo.color = Number("0xFFA800");
              break;
            case "已复核":
              data.stMarkNewInfo.color = Number("0x13C18C");
              break;
            case "已取消":
              data.stMarkNewInfo.color = Number("0x979797");
              break;
            case "待协商":
              data.stMarkNewInfo.color = Number("0xff0000");
              break;
          }
          Monge.Map.Annotation.add({
            data,
            callback: (type, data) => {
              if (type === Monge.CallbackType.DONE) {
                Monge.Map.Annotation.fitTo({ id: data.id });
              }
            }
          });
        } else {
          // 未点击 批注列表展开时，云线都展示
          if (this.annotationList.length > 0) {
            const questionIdList = [];
            for (const element of this.annotationList) {
              if (element.flag23d == 2 && element.modelPageFileName == this.modelPageFileName) {
                // 找出图纸对应的云线
                let color = "";
                switch (element.queStatus) {
                  case "待修改":
                    color = Number("0xd81e06");
                    break;
                  case "已修改":
                    color = Number("0xFFA800");
                    break;
                  case "已复核":
                    color = Number("0x13C18C");
                    break;
                  case "已取消":
                    color = Number("0x979797");
                    break;
                  case "待协商":
                    color = Number("0xff0000");
                    break;
                }
                const data =
                  element.source === "WEB端" ? JSON.parse(element.coordinate) : JSON.parse(element.anchorPoint);
                if (data) {
                  data.stMarkNewInfo.color = color;
                  Monge.Map.Annotation.add({
                    id: element.questionId,
                    data,
                    callback: (type, data) => {
                      const obj = { element, mongeId: data.id };
                      questionIdList.push(obj);
                      // console.log('data.id',element.questionId);
                      this.$store.dispatch("setSpaceQmList", questionIdList);
                    }
                  });
                }
              }
            }
          }
        }
      });
    },

    addListenDwgProp() {
      // 监听图纸点击事件
      Monge.Map.Selector.addSelectionEvent(e => {
        // await this.$nextTick()
        if (!e) {
          Monge.Model.Selector.linkSelect(this.modelIdx, null);
          return;
        }
        const elementId = e.elementId;
        const modelElementId = this.mapModel[elementId];
        if (modelElementId) {
          Monge.Model.Selector.linkSelect(this.modelIdx, modelElementId);
          Monge.Model.Selector.fitTo();
        }
      });
    },
    mapLinkModel() {
      return new Promise((res, rej) => {
        this.modelMap = [];
        this.mapModel = [];
        const mapElementIds = Monge.Map.getLinkElements(); // 图纸
        const rootId = Monge.Model.getRootId(this.modelIdx); // 获取模型根节点id
        // console.log('mapElementIds',mapElementIds);
        const modelElementIds = [];
        Monge.Model.ElementOperator.leafIterator(this.modelIdx, rootId, modelElementId => {
          const attributes = Monge.Model.getProperty(this.modelIdx, modelElementId);
          // console.log('attributes',attributes);
          outloop: for (let i = 0; i < attributes.length; i++) {
            const attr = attributes[i];
            if (attr.name == "#elementId") {
              modelElementIds.push(attr.value);
              for (let j = 0; j < mapElementIds.length; j++) {
                const mapElementId = mapElementIds[j];
                if (mapElementId == attr.value) {
                  this.modelMap[modelElementId] = j;
                  this.mapModel[j] = modelElementId;
                  break outloop;
                }
              }
            }
          }
        });
        // console.log(mapElementIds,modelElementIds);
        // console.log('modelMap',this.modelMap);
        // console.log('mapModel',this.mapModel);
        res();
      });
    },
    // 右键菜单
    onModelMenu() {
      Monge.Model.onCancel(() => {});
      Monge.Model.onMenu(data => {
        this.onContextmenu(data);
      });
    },
    onContextmenu(data) {
      if (!data || !data.funcList || data.funcList.length === 0) return;
      const items = [];
      for (const f of data.funcList) {
        items.push({
          label: f.description,
          value: f.value,
          onClick: () => {
            this.handleClick(f.value, data.componentAttr);
          }
        });
      }
      this.$contextmenu({
        items: items,
        x: data.x,
        y: data.y,
        zIndex: 3,
        minWidth: 230
      });
      return false;
    },
    handleClick(funcType, componentAttr) {
      const FuncType = Monge.Model.MenuFuncType;
      let modelId, elementId;
      if (componentAttr) {
        modelId = componentAttr.modelId;
        elementId = componentAttr.elementId;
      }
      switch (funcType) {
        case FuncType.CANCEL_SELECT.value:
          Monge.Model.Selector.cancelSelect();
          break;
        case FuncType.SELECT_CAT.value:
          Monge.Model.Selector.selectCat();
          break;
        case FuncType.FLY_TO.value:
          Monge.Model.Selector.fitTo();
          break;
        case FuncType.HIDE.value:
          Monge.Model.ElementOperator.hideSelection();
          break;
        case FuncType.HIDE_OTHER.value:
          Monge.Model.ElementOperator.hideOther();
          break;
        case FuncType.SHEER.value:
          Monge.Model.ElementOperator.sheerSelection();
          break;
        case FuncType.CANCEL_SHEER.value:
          Monge.Model.ElementOperator.cancelSheer();
          break;
        case FuncType.SHOW_ALL.value:
          Monge.Model.ElementOperator.cancelHide();
          break;
      }
    },
    getWidth() {
      if (this.showdwg) {
        this.resizeListening = document.getElementsByClassName("resize-bar")[0].offsetWidth;
        this.$parent.$refs.Mbutton.marginLeft = this.resizeListening;
        this.$parent.marginLeft = this.resizeListening;
        Monge.Map.resize();
        Monge.Model.resize();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.modelpage {
  height: 100vh;
  width: 100vw;

  user-select: none;
  overflow: hidden;
  background: #fff;
}

.rightCliMenu {
  width: 150px;
  position: absolute;
  z-index: 4;

  ul > li {
    height: 30px;
    width: 150px;
    text-align: center;
    line-height: 30px;
    font-size: 16px;
    color: #fff;
    background: rgba(0, 0, 0, 0.3);
    cursor: pointer;
    border-bottom: 1px solid #aaaaaa;
  }
  li:hover {
    background: rgba(0, 0, 0, 0.5);
  }
  li:first-child {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  li:last-child {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}

.change {
  // background: url("../images/change.png");
  background-size: 30px 30px;
  z-index: 10;
  position: absolute;
  left: calc(50vw - 15px);
  top: calc(50vh - 15px);
  width: 30px;
  height: 30px;
  display: block;
  cursor: pointer;
  // border: 1px solid #ffffff;
  border-radius: 30px;
}
//拖拽布局
.column-left {
  height: 100vh;
  background-color: #eee;
  position: relative;
  float: left;
  max-width: 1600px;
}

.column-right {
  position: relative;
  height: 60%;
  background-color: #fff;
  box-sizing: border-box;
  overflow: hidden;
}
canvas{
  height: 100%;
}
.resize-save {
  position: absolute;
  top: 0;
  right: 5px;
  bottom: 0;
  left: 0;
  overflow-x: hidden;
  overflow-y: hidden;
  padding-right: 2px;
}

.resize-bar {
  height: inherit;
  resize: horizontal;
  cursor: ew-resize;
  opacity: 0;
  overflow: scroll;
}

/* 拖拽线 */
.resize-line {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  border-right: 2px solid #eee;
  border-left: 1px solid #bbb;
  pointer-events: none;
}

.resize-bar:hover ~ .resize-line,
.resize-bar:active ~ .resize-line {
  border-left: 1px dashed skyblue;
}

.resize-bar::-webkit-scrollbar {
  width: 50vw;
  height: inherit;
}
.closed {
  cursor: pointer;
  font-size: 20px;
  position: absolute;
  z-index: 10;
  top: 10px;
  color: #fff;
}
</style>
